import React from 'react';
import {connect} from 'react-redux';

import {modifyPageLayoutComponents} from '../PageLayout';
import template from '../../templates/Discounts/Discounts.rt';
import DiscountsHeaderTemplate from "../../templates/Discounts/DiscountsPageHeader.rt";
import {getDiscounts} from "./discountsAsyncActions";
import {resetDiscounts} from "./discountsActions";
import DiscountsFooter from "./DiscountsFooter";

class Discounts extends React.Component {

  state = {
    qtFiteredDiscounts: []
  };

  componentDidMount() {
    this.props.getDiscounts();
  }

  componentWillUnmount() {
    this.props.resetDiscounts();
  }

  render = template
}

const mapStateToProps = (store) => {
  return {
    // discounts: store.discountsState.discounts,
  };
};

const mapDispatchToProps = {
  getDiscounts,
  resetDiscounts
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const DiscountsLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(DiscountsHeaderTemplate),
  content: connector(Discounts),
  pageFooter: connector(DiscountsFooter),
});
